import {useEffect, useReducer} from "react";

let cache = {};

const reducer = (state, action) => {
    switch (action.type) {
        case 'setData':
            return action.payload;
        case 'addToFavorite':
            const addedToProgramState = {
                ...state,
                userData: {
                    ...state.userData,
                    isInFavorite: true
                },
            };
            cache[action.conferenceId] = addedToProgramState;

            return addedToProgramState;
        case 'removeFromFavorite':
            const removedFromProgramState = {
                ...state,
                userData: {
                    ...state.userData,
                    isInFavorite: false
                },
            }
            cache[action.conferenceId] = removedFromProgramState;

            return removedFromProgramState;
        case 'checkIn':
            const checkInState = {
                ...state,
                userData: {
                    ...state.userData,
                    isUserCheckedIn: true
                },
            }
            cache[action.conferenceId] = checkInState;

            return checkInState;
        default:
            throw new Error();
    }
}

export default function useEventData(id) {
    const [eventData, dispatch] = useReducer(reducer, cache[id]);

    useEffect(() => {
        if (!cache[id]) {
            fetch('/api/v1/conference/' + id)
                .then(res => res.json())
                .then(
                    (result) => {
                        dispatch({
                            type: 'setData',
                            payload: result,
                        })
                    }
                )
        }
    }, [id]);

    return [eventData, dispatch];
}
